import * as React           from 'react';
import * as PropTypes       from 'prop-types';
import { matchPath }        from 'react-router';
import env                  from '../../env';
import { Tabs, TabContent } from '../../components/Tabs';
import SmartListComponent, { initialState, listReducer, filterReducer, initialFilter } from '../SmartList';
import { FeatureFlag }      from '../../types';
import Header from '../../components/Header';
import DropdownMenu from '../../components/DropdownMenu';
import MenuItem from '../../components/MenuItem';

const ConversationListPlaceholder: React.StatelessComponent<{ session: any, onDesktop: boolean }> = ({ session, onDesktop }, { translate }) => {
    const basePath = window.location.pathname.split('/messenger').join('');
    const hasConversationId = Boolean(matchPath(basePath, { path: '/conversation/:conversationId' })) || Boolean(matchPath(basePath, { path: '/log/:conversationId' }));
    const mobileMenu = []; // (conditionally push more elements in to build up a multi-icon menu
    const [selectedTab, setSelectedTab] = React.useState(0);
    const hasSmartList = (session.features && session.features.length > 0) ? session.features.includes(FeatureFlag.SMARTLIST) : false;
    const [state, dispatchState] = React.useReducer(listReducer, initialState);
    const [filters, dispatchFilters] = React.useReducer(filterReducer, initialFilter);

    const handleSwitchTabs = (index: number) => {
        setSelectedTab(index);
    };

    // @todo Include items as Logout, Settings, Edit my profile, etc...
    mobileMenu.push(
        <DropdownMenu
            className="header__button header__settingsMenu settingsMenu"
            name="header__settingsMenu"
            align="left"
            closeOnOutsideClick={true}
            toggleLabel={translate('actions')}
            key="settingsMenu"
        >
            {session.features.includes(FeatureFlag.CRM) &&
            <MenuItem
                onClickAction={() => (window.location.href = `${env.WEBAPP_HOST}accounts`)}
                label={translate('launch_statflo_crm')}
                target="_blank"
                key="statfloCrm"
            />
            }
        </DropdownMenu>
    );

    const headerRightContent = /* onDesktop */ true ? null : mobileMenu;

    return (
        <>
            <div className="conversationsList__view border-right">
                <Header
                    session={session}
                    title={translate('conversations')}
                    rightContent="renderChildren"
                >
                    {headerRightContent}
                </Header>
                <Tabs onChange={handleSwitchTabs} unread={0}>
                    <TabContent label="Inbox" active enabled>
                        <div className="conversationsList__scroll">
                            <div className="conversationsList__placeholder">
                                <p>{translate('no_open_conversations')}<br />
                                    {translate('start_conversation_account')}</p>
                                <a className="actionButton" href={env.WEBAPP_HOST + 'accounts'}>{translate('view_accounts_convo')}</a>
                            </div>
                        </div>
                    </TabContent>
                    <TabContent label="Smart List" enabled={hasSmartList}>
                        <SmartListComponent
                            translate={translate}
                            state={state}
                            dispatchState={dispatchState}
                            dispatchFilters={dispatchFilters}
                            filters={filters}
                        />
                    </TabContent>
                </Tabs>
            </div>
            {
                // render a placeholder where the conversation will be
                !hasConversationId && onDesktop &&
                <div className="flexbox__column">
                    <div className="flexbox__row empty__state">
                        {selectedTab === 0 && <p>Please select a chat on the left to start messaging</p>}
                        {selectedTab === 1 && <p>To get started, set your filters on the left to start messaging your customers. Happy texting!</p>}
                    </div>
                </div>
            }
        </>
    );
};

export default ConversationListPlaceholder;

ConversationListPlaceholder.contextTypes = {
    translate: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/sections/ConversationsList/ConversationsListPlaceholder.tsx